import { ToolTip, StadiumShippedTooltip } from "@sharedComponents/cards/product/client";
import Multimedia from "@sharedComponents/multimedia";

import { CORE_ON_DEMAND_TEXT } from "@constants/products/listing";

import styles from "./main.module.scss";

import ecofriendlyImg from "@stadium/ui/src/assets/images/eco-friendly.svg";
import coreOnDemandImg from "@stadium/ui/src/assets/images/core-on-demand.svg";
import sustainableImg from "@stadium/ui/src/assets/images/sustainable.svg";
import embroideryImg from "@assets/images/svg/embroidery.svg";

const Badge = ({
  badgeId,
  heading,
  content,
  containerClass,
  badgeImage,
  isNextImage,
}: {
  badgeId: string;
  heading: string;
  content?: string;
  containerClass?: string;
  badgeImage: string;
  isNextImage: boolean;
}) => {
  return (
    <ToolTip
      containerClass={styles.toolTipWrapper}
      heading={heading}
      content={content}
      isLightTheme
      disableOnResponsive
      placement="top-end"
      arrow={true}
    >
      <div id={badgeId} className={containerClass}>
        <Multimedia
          type="image"
          src={badgeImage}
          height={16}
          isNextImage={isNextImage}
          className={styles.qualityImg}
        />
      </div>
    </ToolTip>
  );
};

const ProductBadges = ({
  containerClass,
  isLockerShop,
  sustainable,
  storeProduct,
  ecoFriendly,
  shippedFromStadium,
  showCoreOnDemand,
  isNextImage = false,
}) => {
  return (
    <div className={`${styles.onDemandBadgeCont} ${containerClass}`}>
      {!isLockerShop && sustainable && (
        <Badge
          badgeId="sustainableIcon"
          heading="Sustainable Printing"
          content="We only print once ordered, which reduces waste and preserves resources."
          containerClass={styles.sutainableImgCont}
          badgeImage={sustainableImg}
          isNextImage={isNextImage}
        />
      )}
      {storeProduct?.embroidery && (
        <Badge
          badgeId="embroideryIcon"
          heading="Embroidery"
          containerClass={styles.sutainableImgCont}
          badgeImage={embroideryImg}
          isNextImage={isNextImage}
        />
      )}
      {ecoFriendly && (
        <Badge
          badgeId="ecoFriendlyIcon"
          heading="Eco-friendly"
          content="This item is crafted from sustainable and recycled materials, reducing carbon footprint."
          containerClass={styles.ecoFriendlyImgCont}
          badgeImage={ecofriendlyImg}
          isNextImage={isNextImage}
        />
      )}
      {!!shippedFromStadium && <StadiumShippedTooltip />}
      {showCoreOnDemand && (
        <Badge
          badgeId="coreOnDemandIcon"
          heading="Core On-Demand"
          content={CORE_ON_DEMAND_TEXT}
          badgeImage={coreOnDemandImg}
          isNextImage={isNextImage}
        />
      )}
    </div>
  );
};
export default ProductBadges;
